



<div id="backdrop" class="modal-backdrop" [ngClass]="{ show: showModal }" style="z-index: 900" ></div>
<div class="modal d-block fade" 
  [ngClass]="{ show: showModal }"

  id="listing-dialog" 
  tabindex="-1" role="dialog" aria-labelledby="modalIdLabel">
    <div class="modal-dialog mw-100 w-75" role="document" (click)="onDialogClick($event)">
        <div class="modal-content">
            <div class="modal-header">
                <h5 *ngIf="showModal"><strong>Team</strong> {{customerObject.teamBase?.label}}</h5>
                <button type="button"
                    class="close"
                    (click)="goBack()"
                    aria-label="Close"><span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              
              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <a class="nav-link" routerLink="team-base" routerLinkActive="active">Stammdaten</a>
                </li>  
                <li class="nav-item">
                  <a class="nav-link"  routerLink="team-location" routerLinkActive="active">Einsatzbereich</a>
                </li>  
                <li class="nav-item">
                  <a class="nav-link"  routerLink="team-absences" routerLinkActive="active">Verfügbarkeit</a>
                </li>  
                <li class="nav-item">
                  <a class="nav-link" routerLink="team-classification" routerLinkActive="active">Klassifizierung</a>
                </li> 
              
                <!--li class="nav-item">
                  <a class="nav-link" routerLink="team-notes" routerLinkActive="active" *ngIf="!isNew">Notizen</a>
                </li-->
                <!--li class="nav-item">
                  <a class="nav-link"  routerLinkActive="active" *ngIf="!isNew">Aktionen</a>
                </li-->
              </ul>
              <router-outlet></router-outlet>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" (click)="delete()">löschen</button>
              <button type="button" class="btn btn-primary" (click)="goBack()">schließen</button>
            </div>
        </div>
    </div>
</div>
